export default __webpack_public_path__ + "img/cyidAZKi.5f517f5a.svg";